import React, { useState, useEffect } from "react";
import classes from "./ManageRoles.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { SquarePen, Trash2, Lock } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import closicon from "../../Assets/close.svg";
import Swal from 'sweetalert2';
import ToggleSlider from './ToggleSlider';
import { Spinner, Badge, Button, Modal, Form, Row, Col } from 'react-bootstrap';

const ManageRoles = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [allSelected, setAllSelected] = useState(false);
    const [userPer, setUserPer] = useState("");
    const [selectedRoles, setSelectedRoles] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPermisionOpenModal, setIsPermissionModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [NewUser, setNewUser] = useState([]);
    const [locations, setLocations] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [roles, setRoles] = useState([]);
    const [roleLoading, setRoleLoading] = useState(false);

    // --- NEW: Search state ---
    const [searchTerm, setSearchTerm] = useState("");

    // --- NEW EDIT MODE STATE TRACKERS ---
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingRoleId, setEditingRoleId] = useState(null);

    const pageMap = {
        "/dashboard": "Dashboard",
        "/transactions": "Transactions",
        "/accounts": "Accounting",
        "/reports": "Reports",
        "/banking": "Banking",
        "/settings": "Settings",
    };

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        description: '',
        phone_no: '',
        address: '',
        location_id: '',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const fetchNewUser = async () => {
        try {
            const res = await api.get(`/v1/payroll/role`);
            const newUserData = res.data?.data?.data || res.data?.data || [];
            setNewUser(newUserData);
        } catch (err) {
            console.error("Error fetching user:", err?.response?.data || err.message);
            setError(err.response?.data?.message || "Failed to fetch users. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const fetRoles = async () => {
        setRoleLoading(true);
        try {
            const response = await api.get(`/v1/role/all_permissions`);
            const data = response.data?.data || [];
            setRoles(data);
            
            const initialMap = {};
            data.forEach(permission => {
                initialMap[permission.id] = false;
            });
            setSelectedRoles(initialMap);
        } catch (error) {
            console.error(error.response?.data?.message);
            setRoles([]);
        } finally {
            setRoleLoading(false);
        }
    };

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            setError("Authorization token not found.");
            navigate('/signin');
            return;
        }
        fetchNewUser();
        fetRoles();
    }, [navigate]);

    // --- NEW: Delete Role Handler ---
    const handleDeleteRole = async () => {
        if (!userToDelete) return;
        setSubmitting(true);
        try {
            const payload = withCompanyId({ role_id: userToDelete.id });
            await api.post(`/v1/payroll/role/delete`, payload); // adjust endpoint as needed

            setIsDeleteModalOpen(false);
            Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: `Role "${userToDelete.name}" has been removed.`,
                timer: 2000,
                showConfirmButton: false,
                toast: true,
                position: 'top-end'
            });
            fetchNewUser();
            setUserToDelete(null);
        } catch (err) {
            console.error("Error deleting role:", err);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: err.response?.data?.message || 'Something went wrong.',
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleSelectAllChange = () => {
        const newState = !allSelected;
        const updatedRoles = {};
        roles.forEach(permission => {
            updatedRoles[permission.id] = newState;
        });
        setSelectedRoles(updatedRoles);
        setAllSelected(newState);
    };

    const handleModuleSelectAll = (modulePermissions) => {
        const updated = { ...selectedRoles };
        const isAllGroupChecked = modulePermissions.every(p => updated[p.id]);

        modulePermissions.forEach(permission => {
            updated[permission.id] = !isAllGroupChecked; 
        });

        setSelectedRoles(updated);

        const totalChecked = roles.every(role => updated[role.id]);
        setAllSelected(totalChecked);
    };

    const handleCheckboxChange = (permissionId) => {
        setSelectedRoles(prev => {
            const updated = {
                ...prev,
                [permissionId]: !prev[permissionId]
            };
            const totalChecked = roles.every(role => updated[role.id]);
            setAllSelected(totalChecked);
            return updated;
        });
    };

    // --- OPEN MODAL FOR EDIT MODE ---
    const handleEditClick = (roleItem) => {
        setIsEditMode(true);
        setEditingRoleId(roleItem.id);
        
        setFormData(prev => ({
            ...prev,
            name: roleItem.name || ""
        }));

        const savedPermissionIds = roleItem.permissions?.map(p => p.id) || [];
        const activeSelectionsMap = {};
        
        roles.forEach(role => {
            activeSelectionsMap[role.id] = savedPermissionIds.includes(role.id);
        });

        setSelectedRoles(activeSelectionsMap);
        setAllSelected(roles.length > 0 && roles.every(r => activeSelectionsMap[r.id]));
        setIsModalOpen(true);
    };

    // --- FORM SUBMISSION ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const payloadPermissions = roles
            .filter((item) => selectedRoles[item.id])
            .map((item) => item.id);

        try {
            const payload = {
                name: formData.name, 
                permission: payloadPermissions,
            };
            const body = withCompanyId(payload);

            let response;
            if (isEditMode) {
                response = await api.post(`/v1/payroll/role/update/${editingRoleId}`, body);
            } else {
                response = await api.post(`/v1/payroll/role/store`, body);
            }

            setFormData({ name: "", description: "" });
            const clearedMap = {};
            roles.forEach(p => { clearedMap[p.id] = false; });
            setSelectedRoles(clearedMap);
            setAllSelected(false);
            setIsModalOpen(false);
            setIsEditMode(false);
            setEditingRoleId(null);

            Swal.fire({
                icon: "success",
                title: "Success",
                text: response.data.message || (isEditMode ? 'Role updated successfully!' : 'Role added successfully!'),
                timer: 2000,
                showConfirmButton: false,
            });

            fetchNewUser();
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: isEditMode ? "Failed to Update Role" : "Failed to Add Role",
                text: error.response?.data?.message || "Something went wrong.",
            });
        } finally {
            setSubmitting(false);
        }
    };

    const groupedPermissions = roles.reduce((acc, permission) => {
        const module = permission.module || "Other";
        if (!acc[module]) {
            acc[module] = [];
        }
        acc[module].push(permission);
        return acc;
    }, {});

    // --- FILTER ROLES BY SEARCH ---
    const filteredRoles = NewUser.filter((role) =>
        role.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.PgeContainerDisp}>
                <header className={classes.FrtHeaderOne}>
                    <h2 className={classes.FrtTitleOne}>Manage Roles</h2>
                    <h1 className={classes.Titles}>
                        Create and customize administrative roles, assign system permissions, and control access levels.
                    </h1>
                </header>

                <div className={classes.headerforActions}>
                    <div className={classes.actionsSideRight}>
                        <div className={classes.inputWrapperTxt}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreenLrg} />
                            {/* ✅ Search input with state */}
                            <input 
                                type="text" 
                                className={classes.searchLxtBar} 
                                placeholder="Search roles" 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <button
                        className={classes.btnssBtnss}
                        onClick={() => {
                            setIsEditMode(false);
                            setEditingRoleId(null);
                            setFormData({ name: "", description: "" });
                            const clearedMap = {};
                            roles.forEach(p => { clearedMap[p.id] = false; });
                            setSelectedRoles(clearedMap); 
                            setAllSelected(false); 
                            setIsModalOpen(true); 
                        }}>
                        Add Roles
                    </button>
                </div>

                <div className={classes.newUserCont}>
                    {/* ✅ Table wrapper for horizontal scroll */}
                    <div className={classes.tableResponsiveWrapper}>
                        <table className={classes.newUserTable}>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}>S/N</th>
                                    <th>Name of Role</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th className={classes.actionMove}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    Array(5).fill().map((_, idx) => (
                                        <tr key={idx}>
                                            {Array(5).fill().map((_, i) => (
                                                <td key={i}><Skeleton height={20} style={{ marginBottom: 10 }} /></td>
                                            ))}
                                        </tr>
                                    ))
                                ) : filteredRoles.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} style={{ textAlign: "center" }}>No role found.</td>
                                    </tr>
                                ) : (
                                    filteredRoles.map((user, index) => (
                                        <tr key={user.id}>
                                            <td style={{ width: 40 }}>{index + 1}</td>
                                            <td>{user.name}</td>
                                            <td style={{ width: 200 }}>{new Date(user.created_at).toLocaleDateString()}</td>
                                            <td style={{ width: 200 }}>{new Date(user.updated_at).toLocaleDateString()}</td>
                                            <td className={classes.actionsEditDelete}>
                                                <SquarePen
                                                    size={16}
                                                    className={classes.editActionIcon}
                                                    onClick={() => handleEditClick(user)}
                                                />
                                                <Trash2
                                                    size={16}
                                                    className={classes.deleteActionIcon}
                                                    onClick={() => {
                                                        setUserToDelete(user);
                                                        setIsDeleteModalOpen(true);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* ---------------------- MODAL ---------------------- */}
            {isModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        <div className={classes.modalModalHeader}>
                            <h2>{isEditMode ? "Edit Role" : "Add Role"}</h2>
                            <button className={classes.closeModalBtn} onClick={() => setIsModalOpen(false)}>&times;</button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className={classes.modalModalBody}>
                                <div className={classes.modalFormRow}>
                                    <div className={classes.modalFormGroup}>
                                        <label>Role Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Enter Role Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div>
                                <Col md={12}>
                                    <Form.Group>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <h5>Assign Permission to Role</h5>
                                        </div>
                                        <hr />

                                        {roleLoading ? (
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                                                <Spinner animation="border" variant="success" role="status" />
                                                <span className="mt-2 text-muted">Loading permissions...</span>
                                            </div>
                                        ) : roles.length === 0 ? (
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '150px', color: '#6c757d', fontWeight: 500 }}>
                                                No permission to display
                                            </div>
                                        ) : (
                                            <>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className={classes.customcheckbox1}>
                                                            <Form.Check
                                                                type="checkbox"
                                                                id="global-select-all"
                                                                label="Select all"
                                                                checked={allSelected}
                                                                style={{marginTop: 10}}
                                                                onChange={handleSelectAllChange}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {Object.entries(groupedPermissions).map(([module, permissions]) => {
                                                    const isModuleAllChecked = permissions.every(p => !!selectedRoles[p.id]);

                                                    return (
                                                        <div key={module} style={{ marginBottom: "15px" }}>
                                                            <div style={{
                                                                backgroundColor: "#F5F5F5",
                                                                color: "#2D2D2D",
                                                                padding: "8px",
                                                                borderRadius: "5px",
                                                                marginTop: "10px",
                                                                fontWeight: 700,
                                                            }}>
                                                                {module}
                                                            </div>

                                                            <div className={classes.customcheckbox1} style={{ marginTop: 5, marginBottom: 5 }}>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id={`module-select-all-${module}`}
                                                                    label="Select All Module"
                                                                    checked={isModuleAllChecked}
                                                                    onChange={() => handleModuleSelectAll(permissions)}
                                                                />
                                                            </div>

                                                            {permissions.map(permission => (
                                                                <div key={permission.id} className={classes.customcheckbox1}>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        id={`permission-chk-${permission.id}`}
                                                                        label={permission.name}
                                                                        checked={!!selectedRoles[permission.id]}
                                                                        onChange={() => handleCheckboxChange(permission.id)}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </Form.Group>
                                </Col>
                            </div>

                            <div className={classes.modalFormFooter}>
                                <button type="submit" className={classes.processModalBtn0} disabled={submitting || roleLoading || roles.length === 0}>
                                    {submitting ? 'Processing...' : isEditMode ? 'Update Role' : 'Add Role User'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ---------------------- DELETE MODAL ---------------------- */}
            {isDeleteModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalDeleteContent}>
                        <div className={classes.modalModalHeader}>
                            <h2 style={{ marginBottom: "auto" }}>Delete Role</h2>
                            <button className={classes.closeModalBtn} onClick={() => setIsDeleteModalOpen(false)}>
                                &times;
                            </button>
                        </div>

                        <div className={classes.modalModalBodyText00}>
                            <p>
                                Are you sure you want to delete role:{" "}
                                <strong>{userToDelete?.name}</strong>?
                            </p>
                            <div className={classes.modalFormDelFooter}>
                                {/* ✅ Added onClick handler */}
                                <button 
                                    className={classes.ModalDeleteBtn0} 
                                    onClick={handleDeleteRole}
                                    disabled={submitting}
                                >
                                    {submitting ? 'Deleting...' : 'Delete Role'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default ManageRoles;